import React from "react";
import { Link } from "react-router-dom";
import BrandMark from "../components/BrandMark";
import { useAuth } from "../contexts/AuthContext";
import PublicProgramView from "../components/PublicProgramView";
import {
  PUBLIC_PROGRAM_ID,
  PUBLIC_PROGRAM_ORG_ID,
} from "../publicProgram";

const HomePage: React.FC = () => {
  const { user, signOut } = useAuth();

  return (
    <div className="min-h-screen bg-base-100">
      <header className="bg-base-100 border-b border-base-200">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
          <Link to="/" aria-label="PEAK home" className="shrink-0 hover:opacity-80 transition-opacity">
            <BrandMark />
          </Link>
          <div className="flex items-center gap-4">
            {user?.email && (
              <span className="text-sm text-base-content/70 truncate max-w-[16rem]">
                {user.email}
              </span>
            )}
            <button
              type="button"
              onClick={() => signOut()}
              className="text-sm px-4 py-2 rounded-md border border-base-300 bg-base-100 hover:bg-base-200 transition-colors"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 py-8">
        <PublicProgramView
          orgId={PUBLIC_PROGRAM_ORG_ID}
          programId={PUBLIC_PROGRAM_ID}
        />
      </main>
    </div>
  );
};

export default HomePage;
